export const LANGUAGES = {
  EN: {
    code: 'en',
    name: 'English',
  },
  DE: {
    code: 'de',
    name: 'Deutsch',
  },
  FR: {
    code: 'fr',
    name: 'Français'
  }
};